import { Eye, EyeClosed } from "lucide-react"
import { useState } from "react"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import type { ILoginPayload } from "@/entities/auth/api/post-login.ts"
import { usePostLogin } from "@/features/auth/api/use-post-login.ts"
import { Button, Input } from "@/shared/components"
import { useFetchOneIdUrl } from "@/features/auth/api/use-fetch-one-url"
import Cookies from "js-cookie"
import { Navigate } from "react-router-dom"

export function Login() {
  const { t } = useTranslation("auth")
  const { data } = useFetchOneIdUrl()

  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  const { control, handleSubmit } = useForm<ILoginPayload>({
    defaultValues: { email: "", password: "" }
  })

  const { mutate: postLogin, isPending } = usePostLogin()

  const onSubmit = (data: ILoginPayload) => {
    import("@/pages/dashboard/dashboard-page")
    postLogin(data)
  }
  function togglePasswordVisibility() {
    setIsPasswordVisible(prev => !prev)
  }

  const handleRedirect = () => {
    if (data?.authorization_url) {
      window.location.href = data.authorization_url
    }
  }

  const session_id = Cookies.get("session_id")

  if (session_id) {
    return <Navigate to={"/auth/role-select"} replace={true} />
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="auth-form-wrapper min-w-[400px] bg-white dark:bg-zinc-500">
        <h3 className="auth-form-wrapper__title ">{t("signInSystem")}</h3>
        <div className="items-center w-full auth-form-wrapper__acountlist">
          <div className="flex flex-col w-full gap-4">
            <label>
              <span>{t("username")}:</span>
              <Input.Form control={control} name="email" placeholder={t("usernamePlaceholder")} />
            </label>
            <label>
              <span>{t("password")}:</span>
              <Input.Form
                control={control}
                name="password"
                type={isPasswordVisible ? "text" : "password"}
                placeholder="********"
                endIcon={
                  isPasswordVisible ? (
                    <Eye size={18} className="cursor-pointer" onClick={() => togglePasswordVisibility()} />
                  ) : (
                    <EyeClosed size={18} className="cursor-pointer" onClick={() => togglePasswordVisibility()} />
                  )
                }
              />
            </label>
            <Button loading={isPending} type="submit" className="mt-3" data-testid="submit-button">
              {t("signInAccount")}
            </Button>
          </div>
        </div>
        <div className="w-full bg-gray-300 h-[1px] my-6" />
        {/* <p className="mb-2">{t("oneIdSignInLabel")}:</p> */}
        <button type="button" className="w-full py-3 border rounded-xl bg-[#374D96] text-white" onClick={handleRedirect}>
          {t("oneIdSignIn")}
        </button>
      </div>
    </form>
  )
}
